import { IconButton } from '@breezeventures/ui-kit/icon-button';
import { Icon } from '@breezeventures/ui-kit/next/icon';

import { BusinessSelect, StatusSelect } from './payments-filter-fields';

const FILTER_WIDTH = 'min-w-[180px] flex-1';

type Props = {
  hideMerchantFilter: boolean;
  onFiltersChange: () => void;
  onReset: () => void;
};

export function PaymentsFilters({
  hideMerchantFilter,
  onFiltersChange,
  onReset,
}: Props) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <div className={FILTER_WIDTH}>
        <StatusSelect onChange={onFiltersChange} />
      </div>
      {!hideMerchantFilter && (
        <div className={FILTER_WIDTH}>
          <BusinessSelect onChange={onFiltersChange} />
        </div>
      )}
      <IconButton
        type="button"
        variant="secondary"
        size="l"
        aria-label="Reset filters"
        onClick={onReset}
      >
        <Icon name="cross-s" size={24} version="v1" />
      </IconButton>
    </div>
  );
}
